import template from './modalRemovePeriod.html';
import controller from './modalRemovePeriod.controller';
import './modalRemovePeriod.scss';

let modalRemovePeriodComponent = {
  restrict: 'E',
  bindings: {
    userId: '<',
    userInceptionId: '<',
    isInception: '<',
    onRemove: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default modalRemovePeriodComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/modalRemovePeriod.component.js